import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const ClipboardIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M18.87,3.93L15.14.2c-.13-.13-.31-.2-.49-.2h-7.44c-1.41,0-2.56,1.15-2.56,2.56v1.16h-1.16c-1.41,0-2.56,1.15-2.56,2.56v11.16c0,1.41,1.15,2.56,2.56,2.56h9.3c1.41,0,2.56-1.15,2.56-2.56v-1.16h1.16c1.41,0,2.56-1.15,2.56-2.56V4.42c0-.18-.07-.36-.2-.49ZM15.35,2.38l1.34,1.34h-1.34v-1.34ZM13.95,17.44c0,.64-.52,1.16-1.16,1.16H3.49c-.64,0-1.16-.52-1.16-1.16V6.28c0-.64.52-1.16,1.16-1.16h1.16v8.6c0,1.41,1.15,2.56,2.56,2.56h6.74v1.16ZM16.51,14.88H7.21c-.64,0-1.16-.52-1.16-1.16V2.56c0-.64.52-1.16,1.16-1.16h6.74v3.02c0,.39.31.7.7.7h3.02v8.6c0,.64-.52,1.16-1.16,1.16Z" />
  <path d="M14.65,11.16h-5.58c-.39,0-.7.31-.7.7s.31.7.7.7h5.58c.39,0,.7-.31.7-.7s-.31-.7-.7-.7Z" />
  <path d="M14.65,7.44h-5.58c-.39,0-.7.31-.7.7s.31.7.7.7h5.58c.39,0,.7-.31.7-.7s-.31-.7-.7-.7Z" />
 </svg>,
 "Clipboard"
);
